const colors = {
  zizziBlue: '#1D3E4B',
  cream: '#FFFEF1',
  orangeAurora: '#E76952',
  chiantiRed: '#750B0D',
  chiantiRedDarker: '#5E090A',
  brightRed: '#E21907',
  brightRedDarker: '#B51406',
  brown: '#714D3F',
  blushBrown: '#E8CDC3',
  copper: '#A2523B',
  brightYellow: '#FAC710',
  darkGreen: '#036D37',
  lightGreen: '#7D9519',
  dustyPink: '#FDACAA',
  lightBlue: '#BBCADA',
  white: '#FFFFFF',
  black: '#000000',
  green: {
    50: '#E6F4EC',
    100: '#CDEBDA',
    200: '#9FD9BA',
    300: '#6DC998',
    400: '#3BB972',
    500: '#1E9C58',
    600: '#147C45',
    700: '#0B5F35',
    800: '#024927',
  },
  yellow: {
    50: '#FFF9E5',
    100: '#FFF3BF',
    200: '#FFEB8A',
    300: '#FFE154',
    400: '#FAC710',
    500: '#E0B210',
    600: '#C69E0F',
    700: '#A7840D',
    800: '#896B0B',
  },
  pink: {
    50: '#FFF1F2',
    100: '#FFD5D7',
    200: '#FFA3A7',
    300: '#FF6B72',
    400: '#FF484F',
    500: '#E9383F',
    600: '#CC353A',
    700: '#A92A2F',
    800: '#861F23',
  },
  neutral: {
    50: '#F1F0EC',
    100: '#E8E6DF',
    200: '#DDDAD1',
    300: '#C7C4BB',
    400: '#B5B2A9',
    500: '#9A9890',
    600: '#75736C',
    700: '#494842',
    800: '#32312D',
  },
  // legacy colors
  blue200: '#6D8FA4',
  blue300: 'rgba(38, 61, 75, 0.3)',
  blue500: '#263D4B',
  blue50: '#BBCADA',
  blue600: '#142C3A',
  blue700: '#0C202D',
  blueDeselected: 'rgba(38,61,75, 0.8)',
  blueDisabled: 'rgba(38,61,75, 0.5)',
  blueLight: 'rgb(38, 61, 75, 0.1)',
};

export default colors;
